var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconItSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2682 8.14021C21.6218 7.71593 21.5645 7.08537 21.1402 6.7318C20.7159 6.37824 20.0853 6.43556 19.7318 6.85984L14.5 13.5L12.2071 10.7929C11.8166 10.4024 11.1834 10.4024 10.7929 10.7929C10.4024 11.1834 10.4024 11.8166 10.7929 12.2071L14.5 16.5L21.2682 8.14021Z",
    fill: "#FF552E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2C2 0.89543 2.89543 0 4 0H28C29.1046 0 30 0.895431 30 2L30 20L32 30V31C32 31.5523 31.5523 32 31 32H1C0.447715 32 0 31.5523 0 31V30L2 20V2ZM28 3H4V20H28V3ZM9.45058 25.9448C9.47871 25.6916 9.69275 25.5 9.94752 25.5H22.0525C22.3073 25.5 22.5213 25.6916 22.5494 25.9448L22.9383 29.4448C22.9712 29.741 22.7394 30 22.4414 30H9.55863C9.26063 30 9.02878 29.741 9.06169 29.4448L9.45058 25.9448Z",
    fill: "#FF552E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconItSupport);
export default __webpack_public_path__ + "static/media/icon-itSupport.e8deac0587c81a332ccec2d01f51ebc9.svg";
export { ForwardRef as ReactComponent };